import { Component, OnInit } from '@angular/core';
import { AttemptHistory, JWTUser } from 'Model';
import { AttemptService } from 'app/services/attempt.service';
import { UtilserviceService } from 'app/services/utilservice.service';

@Component({
  selector: 'app-attempt-history',
  templateUrl: './attempt-history.component.html',
  styleUrls: ['./attempt-history.component.scss']
})
export class AttemptHistoryComponent implements OnInit {

  history: Array<AttemptHistory> = [];
  subjectMaxArray = [];
  disableButton = false;
  style: any;

  constructor(private attmp: AttemptService, public util: UtilserviceService) { }

  async ngOnInit() {
    let user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
    let data = await this.attmp.getAttemptsHistory(user.email);
    this.history = data.history;
    this.subjectMaxArray = this.generateSubjectArray(data.subjectMaxCount);
    this.style = this.util.getDomainEnviroment().style;
  }
  generateSubjectArray(length: number): any[] {
    return length > 0 ? Array(length).fill(0) : [];
  }
  async openAttemptScript(attempts: AttemptHistory) {

    try {
      this.disableButton = true;
      let data = await this.attmp.getAttemptScript(attempts.scheduleId);

      if (data.res.length > 0) {
        const base64String = data.res;

        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const url = URL.createObjectURL(blob);
        window.open(url);
      }

    } catch (error) {
      console.log(error);
    } finally {
      this.disableButton = false;
    }

  }
  getSubjectScore(subject, scoreList) {
    // Find the score for the given subject
    if (!subject) {
      return "";
    }
    let result = scoreList.find(item => item.subject === subject);
    if (result) {
      return `${subject} (${result.score})`;
    } else {
      return `${subject}`;
    }
  }
}
